import throttle from 'lodash/throttle';
import HandleForm from '~scripts/components/forms/forms';
import { getCookie } from '~scripts/core/helpers';

function doSubmit(form) {
  const formData = new FormData(form);
  const body = Object.fromEntries(formData.entries());

  // ADDITIONAL DATA
  // type
  body.type = form.dataset.type;

  // roistat
  const cookieRoistatVisit = getCookie('roistat_visit');
  if (cookieRoistatVisit) {
    body.roistat = cookieRoistatVisit;
  }

  return fetch('/subscribe', {
    method: 'post',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then((r) => r.json().then((json) => [r.status, json]))
    .then(([status, json]) => {
      if (status !== 200) {
        if (json.email) {
          // Сообщение про емейл
          return Promise.reject(json);
        }
      }

      return json;
    })
    .catch((err) => {
      if (err.email) {
        // Сообщение про емейл
        return Promise.reject(err.email);
      }

      return Promise.reject('Что-то пошло не так. Попробуйте ещё раз.');
    });
}

export default function initSubscribeForm(form, ...callbacks) {
  if (!form) {
    return;
  }

  const handleForm = new HandleForm(form);

  function success() {
    handleForm.handleSuccess();

    if (callbacks && Array.isArray(callbacks)) {
      callbacks.forEach((callback) => {
        if (typeof callback === 'function') {
          callback();
        }
      });
    }
  }

  function error(error) {
    handleForm.handleError(error);
  }

  const handleSubmit = throttle(() => {
    if (handleForm.getSending()) {
      return;
    }

    if (!handleForm.checkValidity()) {
      return;
    }

    handleForm.setSending(true);

    handleForm.disableSubmit();

    doSubmit(form)
      .then(success, (err) => {
        const message = err.msg || err.message || '';

        if (message.indexOf('is already subscribed')) {
          success();
        } else {
          error(message, form); // Крайне маловероятный сценарий
        }
      })
      .finally(() => {
        handleForm.setSending(false);

        handleForm.enableSubmit();
      });
  }, 100);

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    handleSubmit();
  });
}
